"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlateButton = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _usePropsUpdatedChildren = require("../../helpers/usePropsUpdatedChildren");

var _counter = require("./counter");

var _icon = require("./icon");

var _loadStyles = _interopRequireDefault(require("load-styles"));

var _excluded = ["children", "classes", "view", "hoverType", "noBg"],
    _excluded2 = ["classes"],
    _excluded3 = ["classes"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

(0, _loadStyles.default)(".c047ad810{outline:0;background:0 0;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;padding:0;-webkit-user-select:none;-ms-user-select:none;user-select:none;max-width:100%;box-sizing:border-box;padding:.3125rem .25rem;display:inline-flex;align-items:center;min-height:1.75rem;font-size:.75rem;font-weight:500;line-height:1rem;border-radius:.25rem;transition:all var(--animation-timing-def) ease;transition-property:color,opacity,background}.c047ad810:not(.c87a652fa){cursor:pointer}.c047ad810:not(.c87a652fa):active{opacity:.5}.cb54f6d91{color:var(--color-gray-90)}.cb54f6d91 .c6c924fe6{color:var(--color-gray-80)}.cb54f6d91 .c4c769bf2{background:var(--color-gray-20)}.cb54f6d91.c55cf463a{background:var(--color-gray-10)}.cb54f6d91.c87a652fa{color:var(--color-gray-40)}.cb54f6d91.c87a652fa .c6c924fe6{color:var(--color-gray-30)}.cb54f6d91.c87a652fa .c4c769bf2{background:var(--color-gray-10)}.cb54f6d91.c87a652fa.c55cf463a{background:rgba(247,250,252,.6)}.ce7d3f47a{color:var(--color-blue-90)}.ce7d3f47a .c6c924fe6{color:var(--color-blue-80)}.ce7d3f47a .c4c769bf2{background:var(--color-gray-20)}.ce7d3f47a.c55cf463a{background:var(--color-gray-10)}.ce7d3f47a.c87a652fa{color:#7e82d9}.ce7d3f47a.c87a652fa .c6c924fe6{color:rgba(126,130,217,.6)}.ce7d3f47a.c87a652fa .c4c769bf2{background:var(--color-gray-10)}.ce7d3f47a.c87a652fa.c55cf463a{background:rgba(247,250,252,.6)}.c844bcf2f{color:var(--color-gray-10)}.c844bcf2f .c6c924fe6{color:var(--color-gray-20)}.c844bcf2f .c4c769bf2{background:var(--color-gray-70)}.c844bcf2f.c55cf463a{background:var(--color-gray-80)}.c844bcf2f.c87a652fa{color:var(--color-gray-20)}.c844bcf2f.c87a652fa .c6c924fe6{color:var(--color-gray-30)}.c844bcf2f.c87a652fa .c4c769bf2{background:var(--color-gray-60)}.c844bcf2f.c87a652fa.c55cf463a{background:var(--color-gray-50)}.c8dfb857d:not(.c87a652fa):hover{color:var(--color-blue-90);background:var(--color-blue-20)}.c8dfb857d:not(.c87a652fa):hover .c6c924fe6{color:var(--color-blue-80)}.c8dfb857d:not(.c87a652fa):hover .c4c769bf2{background:var(--color-blue-50)}.c8dfb857d:not(.c87a652fa):hover.c55cf463a{background:var(--color-blue-20)}.c6b0a05f1:not(.c87a652fa):hover{color:var(--color-red-90);background:var(--color-red-20)}.c6b0a05f1:not(.c87a652fa):hover .c6c924fe6{color:var(--color-red-80)}.c6b0a05f1:not(.c87a652fa):hover .c4c769bf2{background:var(--color-red-50)}.c6b0a05f1:not(.c87a652fa):hover.c55cf463a{background:var(--color-red-20)}.c982b1bec:not(.c87a652fa):hover{color:#fff}.c982b1bec:not(.c87a652fa):hover .c6c924fe6{color:var(--color-gray-10)}.c982b1bec:not(.c87a652fa):hover .c4c769bf2{background:var(--color-gray-90)}.c982b1bec:not(.c87a652fa):hover.c55cf463a{background:var(--color-black-d)}");
var styles = {
  root: 'c047ad810',
  '--disabled': 'c87a652fa',
  '--view-usual': 'cb54f6d91',
  icon: 'c6c924fe6',
  counter: 'c4c769bf2',
  '--bg': 'c55cf463a',
  '--view-bright': 'ce7d3f47a',
  '--view-dark': 'c844bcf2f',
  '--hover-usual': 'c8dfb857d',
  '--hover-warning': 'c6b0a05f1',
  '--hover-dark': 'c982b1bec'
};

var PlateButton = function PlateButton(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      view = props.view,
      hoverType = props.hoverType,
      noBg = props.noBg,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var disabled = rest.disabled;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  var updateCounterProps = (0, _react.useCallback)(function (_ref) {
    var classes = _ref.classes,
        rest = (0, _objectWithoutProperties2.default)(_ref, _excluded2);
    return _objectSpread({
      classes: _objectSpread(_objectSpread({}, classes), {}, {
        counter: (0, _classnames.default)(classes.counter, cn.counter)
      })
    }, rest);
  }, [cn.counter]);
  var childTypes = (0, _react.useMemo)(function () {
    return [_counter.PlateButtonCounter];
  }, []);
  var updatedChildren = (0, _usePropsUpdatedChildren.usePropsUpdatedChildren)(children, childTypes, updateCounterProps);
  var updateIconProps = (0, _react.useCallback)(function (_ref2) {
    var classes = _ref2.classes,
        rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded3);
    return _objectSpread({
      classes: _objectSpread(_objectSpread({}, classes), {}, {
        root: (0, _classnames.default)(classes.root, cn.icon)
      })
    }, rest);
  }, [cn.icon]);
  var childTypesIcon = (0, _react.useMemo)(function () {
    return [_icon.PlateButtonIcon];
  }, []);
  var updatedChildrenIcon = (0, _usePropsUpdatedChildren.usePropsUpdatedChildren)(updatedChildren, childTypesIcon, updateIconProps);
  return /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
    className: (0, _classnames.default)(cn.root, cn.view[view], cn.hover[hoverType], (_classNames = {}, (0, _defineProperty2.default)(_classNames, cn.disabled, disabled), (0, _defineProperty2.default)(_classNames, cn.bg, !noBg), _classNames))
  }, rest), updatedChildrenIcon);
};

exports.PlateButton = PlateButton;
var view = ['usual', 'bright', 'dark'];
var hoverType = ['usual', 'warning', 'dark'];
PlateButton.modes = {
  view: view,
  hoverType: hoverType
};
PlateButton.propTypes = {
  /* component logic props */
  children: _propTypes.node.isRequired,
  disabled: _propTypes.bool,

  /* styling modificators */
  view: (0, _propTypes.oneOf)(view),
  hoverType: (0, _propTypes.oneOf)(hoverType),
  noBg: _propTypes.bool,

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
PlateButton.defaultProps = {
  disabled: false,
  noBg: false,
  classes: {},
  view: 'usual',
  hoverType: 'usual'
};